module.exports = ":host ::ng-deep .mat-nav-list .mat-list-item .mat-line {\n  white-space: pre-wrap !important; }\n"